import * as tslib_1 from "tslib";
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Actions, Effect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { OrderService } from '../services/orders.service';
import * as meta from '../actions/meta';
import * as facet from '../actions/facets';
import * as order from '../actions/orders';
import * as fromOrders from '../reducers';
var FacetEffects = /** @class */ (function () {
    function FacetEffects(actions$, store, orderSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.orderSvc = orderSvc;
        this.initFacetGroups$ = this.actions$.ofType(facet.INIT_GROUPS).pipe(switchMap(function (action) {
            return _this.orderSvc.getFacetGroups().pipe(map(function (groups) { return new facet.InitGroupsSuccess(groups); }), catchError(function (e) { return of(new facet.InitGroupsFailed(e)); }));
        }));
        this.initFacets$ = this.actions$.ofType(facet.INIT_FACETS).pipe(switchMap(function (action) {
            return _this.orderSvc.getFacets().pipe(map(function (facets) { return new facet.InitFacetsSuccess(facets); }), catchError(function (e) { return of(new facet.InitFacetsFailed(e)); }));
        }));
        this.initCompleted$ = this.actions$.ofType(meta.INIT_SUCCESS, meta.INIT_SKIPPED).pipe(map(function (action) { return new facet.Load(); }));
        this.loadFacets$ = this.actions$.ofType(facet.LOAD).pipe(withLatestFrom(this.store.pipe(select(fromOrders.getAppliedFacets)), function (action, applied) { return applied; }), switchMap(function (applied) {
            return _this.orderSvc.getFacetCounts(applied).pipe(map(function (counts) { return new facet.LoadSuccess(counts); }), catchError(function (e) { return of(new facet.LoadFailed(e)); }));
        }));
        this.applyFacets$ = this.actions$.ofType(facet.APPLY).pipe(withLatestFrom(this.store.pipe(select(fromOrders.isInitialized)), function (action, initialized) { return initialized; }), filter(function (initialized) { return initialized; }), switchMap(function (initialized) {
            return of(new facet.Load(), new order.Load());
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initFacetGroups$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initFacets$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initCompleted$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "loadFacets$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "applyFacets$", void 0);
    return FacetEffects;
}());
export { FacetEffects };
